// CostManagement — CCPD's LLM Cost Management dashboard, embedded in the console.
// Same mechanism as ExploreGraph: iframe CCPD's own /dash/cost surface (fronted by
// Caddy on :8544) with ?embed=1 for chromeless mode (no CCPD sidebar). Shows the
// per-agent / per-model token + spend data from mv_llm_call_summary.
export default function CostManagement() {
  const src = `https://${window.location.hostname}:8544/dash/cost?embed=1`;
  // Fill the content area: AppShell's main layout is 100vh and PageContainer adds
  // 36px vertical padding (12 top + 24 bottom). Size the iframe to the viewport.
  return (
    <iframe
      src={src}
      title="CCPD Cost Management"
      style={{ width: "100%", height: "calc(100vh - 36px)", border: "none", display: "block" }}
      allow="clipboard-read; clipboard-write"
    />
  );
}
